import type { Wrex } from '@lumapps/wrex/types';

import { EMBEDDED_VIDEO } from '../constants';
import type { EmbeddedVideoElement } from '../types';

/** Create an embedded video element */
export const createEmbeddedVideo = (attributes: Wrex.ElementAttributes<EmbeddedVideoElement>): EmbeddedVideoElement => {
    return { type: EMBEDDED_VIDEO, ...attributes, children: [{ text: '' }] };
};
